"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M15.41 16.59 10.83 12l4.58-4.59L14 6l-6 6 6 6z"
}), 'KeyboardArrowLeftTwoTone');